import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackactionService {

  private cancelTrigger = new Subject<void>();
  cancel$ = this.cancelTrigger.asObservable();
  isFormActive = false;

  triggerCancel() {
    this.cancelTrigger.next();
  }
}
